import { styled } from "@mui/material"
import { palette } from "view/themes/palette"

export const Wrapper = styled("div")(({ theme }) => ({
  display: "flex",
  flexGrow: 1,
  zIndex: 1,
  minHeight: "100vh",
  backgroundColor: palette.white,
  position: "relative",
}))

export const LeftBlock = styled("div")(() => ({
  flexShrink: 0,
}))

export const RightBlock = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  flexGrow: 2,
}))

export const Content = styled("div")(({ theme }) => ({
  padding: "0 0 24px",
}))

export const LogoIcon = styled("img")(() => ({
  marginLeft: "4px",
}))

export const LogoMiniIcon = styled("img")(() => ({
  marginLeft: "-3px",
}))
